/**
 * @fileoverview Event-selection side effects for Reports filter panels.
 * @module pages/reports/reportEventSelection
 */
import { getCustomerCompanyUsersBasicInfoByEventId } from "../../logic/customerCompanyUser";
import { REPORT_OPTION } from "../../utils/reportConstants.js";

const mapCompaniesWithSearch = (companies) =>
  companies.map((company) => ({
    ...company,
    search: company.nombreComercial.toLowerCase(),
  }));

const resetBuyerCompaniesForEvent = (ctx) => {
  ctx.setBuyerCompaniesOptions(ctx.allBuyerCompanies);
  ctx.setSelectedBuyerCompanies([]);
};

const loadBuyerCompaniesForEvent = async (event, ctx) => {
  const buyerCompanies = await getCustomerCompanyUsersBasicInfoByEventId(
    event._id,
    ctx.navigate,
  );
  ctx.setBuyerCompaniesOptions(mapCompaniesWithSearch(buyerCompanies));
  ctx.setSelectedBuyerCompanies([]);
};

const handleBuyerReportEvent = async (event, ctx) => {
  ctx.setSelectedEvent(event);
  if (!event) {
    resetBuyerCompaniesForEvent(ctx);
    return;
  }
  if (event._id !== ctx.selectedEvent?._id) {
    await loadBuyerCompaniesForEvent(event, ctx);
  }
};

const resetB2bBuyerCompaniesForEvent = (ctx) => {
  ctx.setB2bBuyerCompaniesOptions(ctx.allB2bBuyerCompanies);
  ctx.setSelectedB2bBuyerCompanies([]);
};

const loadB2bBuyerCompaniesForEvent = async (event, ctx) => {
  const b2bBuyerCompanies = await getCustomerCompanyUsersBasicInfoByEventId(
    event._id,
    ctx.navigate,
  );
  const searchableCompanies = mapCompaniesWithSearch(b2bBuyerCompanies);
  ctx.setB2bBuyerCompaniesOptions(searchableCompanies);
  ctx.setAllB2bBuyerCompanies(searchableCompanies);
  ctx.setSelectedB2bBuyerCompanies([]);
};

const handleB2bAttendanceEvent = async (event, ctx) => {
  ctx.setSelectedB2bEvent(event);
  if (!event) {
    resetB2bBuyerCompaniesForEvent(ctx);
    return;
  }
  if (event._id !== ctx.selectedB2bEvent?._id) {
    await loadB2bBuyerCompaniesForEvent(event, ctx);
  }
};

const EVENT_HANDLERS = {
  [REPORT_OPTION.TABLES]: (event, ctx) => ctx.setSelectedEvent(event),
  [REPORT_OPTION.BUYER_LOGS]: handleBuyerReportEvent,
  [REPORT_OPTION.B2B_ATTENDANCE]: handleB2bAttendanceEvent,
  [REPORT_OPTION.GENERAL_B2B]: (event, ctx) => ctx.setSelectedB2bEvent(event),
  [REPORT_OPTION.MEMBER_INVOICE]: (event, ctx) => ctx.setSelectedEvent(event),
  [REPORT_OPTION.NON_MEMBER_INVOICE]: (event, ctx) =>
    ctx.setSelectedEvent(event),
  [REPORT_OPTION.GENERAL_APPOINTMENTS]: (event, ctx) =>
    ctx.setSelectedEvent(event),
  [REPORT_OPTION.APPOINTMENT_DETAILS]: (event, ctx) =>
    ctx.setSelectedEvent(event),
  [REPORT_OPTION.REQUIREMENTS]: (event, ctx) => ctx.setSelectedEvent(event),
  [REPORT_OPTION.VIRTUAL_REGISTRATION]: (event, ctx) =>
    ctx.setSelectedEvent(event),
};

/** Applies report-type-specific event selection side effects. */
export const handleReportEventSelection = async (event, ctx) => {
  const handler = EVENT_HANDLERS[ctx.selectedReportOption?.value];
  if (handler) {
    await handler(event, ctx);
  }
};
